import styled, { css } from 'styled-components';

import { SpaceBetweenBlock } from '../../../../styled';

export const Wrapper = styled(SpaceBetweenBlock)`
  height: 56px;
  padding: 4px 0 0;
  box-sizing: border-box;
  flex-direction: column;
  align-items: initial;
  overflow: hidden;
`;

export const TitleWrapper = styled.div`
  display: flex;
`;

export const NumbersWrapper = styled(SpaceBetweenBlock)`
  overflow: hidden;
  align-items: end;
`;

const TitleLinkStyles = css`
  &:hover {
    color: #0064d6;
    cursor: pointer;
  }
`;

export const Title = styled.div<{ isLink: boolean }>`
  ${(p) => p.theme.typography.label};
  color: ${({ theme, isLink }) => (isLink ? theme.colors.brand : theme.colors.muted)};
  margin-right: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${({ isLink }) => isLink && TitleLinkStyles}};
`;

export const NumberStyle = styled.div<{ isBrandColor?: boolean }>`
  ${(p) => p.theme.typography.accent};
  ${(p) => p.isBrandColor && `color: ${p.theme.colors.brand}`};
`;

export const NumberChangeStyle = styled.div<{ isHigher: boolean }>`
  color: ${({ theme, isHigher }) => (isHigher ? theme.colors.action : theme.colors.danger)};
  height: 32px;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const SpinnerWrapper = styled.div`
  margin-top: 8px;
  margin-left: auto;
  margin-right: auto;
  min-height: 32px;
`;

export const ChevronStyle = styled.div`
  position: relative;
  bottom: -8px;
  display: inline-block;
`;
